import {Component, input} from "@angular/core";
import {EventColors} from "@models";
import {Translations} from "../../../../../sim.translations.barrel";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {CustomColorMapping} from "../../../models/SimEventPalette";
import {MatOption} from "@angular/material/autocomplete";
import {TranslateModule} from "@ngx-translate/core";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatSelect} from "@angular/material/select";
import {MatIcon} from "@angular/material/icon";

@Component({
	selector: "sim-color-select",
	templateUrl: "./color-select.component.html",
	styleUrl: "./color-select.component.scss",
	standalone: true,
	imports: [MatOption, TranslateModule, ReactiveFormsModule, MatFormField, MatSelect, MatLabel, MatIcon],
})
export class ColorSelectComponent {
	public formCtrl = input.required<FormControl<number>>();
	protected readonly Colors = EventColors;
	protected readonly T = Translations;
	protected readonly ColorMapping = CustomColorMapping;
	protected readonly ColorKeys = Object.keys(EventColors)
		.map(Number)
		.filter((key) => !isNaN(key));
}
